import React from 'react';
import SVGImage from '../layout/SVGImage';
import { useTranslation } from 'react-i18next';
import { OutlinedButton } from '../common/OutlinedButton';
import { ExcelExportButton } from '../common/ExcelExportButton';
import { OperationManagementPowerPlantRegistrationModalExcelItem } from './OperationManagementPowerPlantRegistrationModalExcelItem';

interface OperationManagementPowerPlantRegistrationModalExcelProps {
  testId?: string;
  className?: string;
  data?: string;
}

export const OperationManagementPowerPlantRegistrationModalExcel: React.FC<
  OperationManagementPowerPlantRegistrationModalExcelProps
> = ({ testId, className, data }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`rounded-[10px] bg-light-2 p-[30px] ${className}`}
    >
      {data ? (
        <>
          <OperationManagementPowerPlantRegistrationModalExcelItem
            text={data}
            testId={`${testId}-item`}
          />
        </>
      ) : (
        <>
          <SVGImage name="excel" width={28} height={28} />
          <p className="noto-13-normal mt-[13px] leading-[23px] text-dark-10">
            {t('management.excelBody')}
          </p>
        </>
      )}
      <OutlinedButton
        text={t('management.addFile')}
        isClicked={false}
        className="mt-4 h-[32px] w-[80px] border-light-7 text-dark-5 [&]:noto-12-medium [&>p]:m-0 [&>p]:my-[4.5px] [&>p]:w-auto"
      />
      <ExcelExportButton
        text={t('management.downloadSampleFile')}
        className="mt-[47px] w-[181px] px-5 [&]:justify-start"
      />
    </div>
  );
};
